const nameSpace = 'batchDownload';

export default nameSpace;
